/**
 * Retorna un objeto con los permisos de la sección.
 *
 * @param {Array} permissions - Array con los permisos.
 * @param {string} title - Título de la sección de la que se quieren obtener los permisos.
 * @returns {Object} - Objeto con los permisos de la sección.
 */
function createPermsObj(permissions, title) {
  const permissionsWidgets = permissions.find((item) => item.title === title);

  if (permissionsWidgets) {
    return permissionsWidgets.permissions.reduce(
      (result, { value, checked }) => ({ ...result, [value]: checked }),
      {}
    );
  }

  return null;
}

export default createPermsObj;
